
import { 
  signOut, 
  onAuthStateChanged,
  User,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { auth } from './firebase';
import { dbService } from './dbService';
import { UserRecord } from './types';
import { serverTimestamp } from 'firebase/firestore';

const googleProvider = new GoogleAuthProvider();

export const authService = {
  login: async (): Promise<UserRecord | null> => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Check if user record exists
      let userRecord = await dbService.getUserRecord(user.uid);
      
      if (!userRecord) {
        // First time login - create user record
        // Default role is 'user' unless it's the primary admin
        const isPrimaryAdmin = user.email === 'radhikarans2901@gmail.com';
        
        userRecord = {
          uid: user.uid,
          email: user.email || '',
          displayName: user.displayName || '',
          photoURL: user.photoURL || '',
          isApproved: isPrimaryAdmin, // Auto-approve the bootstrap admin
          role: isPrimaryAdmin ? 'admin' : 'user',
          addedAt: serverTimestamp() as any // Using serverTimestamp as requested
        } as any;
        
        await dbService.saveUserRecord(userRecord);
        
        // Fetch it back to get the proper object if needed, 
        // but for the first return we can just use the local object
      }
      
      return userRecord;
    } catch (error: any) {
      console.error("Login failed:", error);
      if (error.code === 'auth/popup-blocked') {
        throw new Error("Sign-in popup was blocked. Please allow popups for this site.");
      }
      throw new Error("Failed to sign in. Please try again.");
    }
  },
  logout: async () => {
    await signOut(auth);
  },
  onAuthUpdate: (callback: (user: User | null) => void) => {
    return onAuthStateChanged(auth, callback);
  },
  getCurrentUser: () => auth.currentUser
};
